// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"b7345f04","367":"06c683b0","396":"9ff82bcf","427":"476e568a"}[chunkId] + ".chunk.css";
};